import { Environment } from "./environment.interface";

export const environment: Environment = {
	production: true,
	brands: {
		enelx: {
			globalNavUrl: 'https://global-nav.svcs.enelx.net/api/v1',
			baseUrl: 'https://flex-home.apps.enelx.com/v1'
		}
	},
	cdn: 'https://cdn.dev-apps.enelx.net',
	defaults: {
		brand: 'enelx',
		locale: 'en-us',
		apiLocale: 'en_US'
	},
	externalUrls: {
		activeEvents: 'https://active-dispatches.apps.enelx.com',
		com: 'https://customer-offers.apps.enelx.com',
		trends: 'https://trends.apps.enelx.com',
	}
};
